import { render, staticRenderFns } from "./Municipalities.vue?vue&type=template&id=1cdeca3d&scoped=true&"
import script from "./Municipalities.vue?vue&type=script&lang=js&"
export * from "./Municipalities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdeca3d",
  null
  
)

export default component.exports